export default {
  // Page title
  'page.title': 'Stopwatch',
  
  // How to use
  'howto.title': 'How to Use',
  'howto.step1': 'Click "Start" button to start the stopwatch, display format: minutes:seconds.centiseconds',
  'howto.step2': 'Click "Pause" to pause timing when stopwatch is running, click "Start" again to continue',
  'howto.step3': 'Click "Reset" button to reset stopwatch to zero and stop timing',
  'howto.step4': 'Stopwatch supports millisecond precision display, suitable for scenarios requiring precise timing',
  
  // User reviews
  'reviews.title': 'User Reviews',
  'reviews.michaelRunner': 'Essential training tool! Millisecond precision allows me to accurately record each sprint performance, simple and fast operation.',
  'reviews.chefJohnson': 'Cooking timer magic! Stir-frying, boiling noodles, steaming eggs all need precise timing, this stopwatch helps me make perfect dishes.',
  'reviews.sarahStudent': 'Essential for exam simulation! Used to practice answering time, clean interface won\'t distract attention, improved answering efficiency.',
  'reviews.coachWilliams': 'Great assistant for training courses! Interval training and planks need precise timing, students love it.',
  'reviews.drAnderson': 'Medical work often requires precise timing, this stopwatch is simple and reliable, a great assistant for my clinical work.',
  
  // User names
  'user.michaelRunner': 'Michael Runner',
  'user.chefJohnson': 'Chef Johnson',
  'user.sarahStudent': 'Sarah Student',
  'user.coachWilliams': 'Coach Williams',
  'user.drAnderson': 'Dr. Anderson',
  
  // Keywords section
  'keywords.stopwatch': 'stopwatch timer precision timing what time is it now',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};